import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutRioGrande() {
  return <TablaConciliacion nombreUseCase="AUTOPISTARIOGRANDE" titulo="AUTOPISTA RIO GRANDE" />;
}

export default TablaAutRioGrande;
